// The serializer is a pure structural mapper over loosely-typed plan filters
// (callers pass `any`-typed plan.filters). Fields it does not inspect are typed
// `unknown` and passed through verbatim.
export interface SubPlanFilter {
  tabname?: string
  countries?: number[] | null
  types?: unknown
  assets_excluded?: unknown
  assets_included?: unknown
  panels?: unknown
  panelsExcluded?: unknown
  package?: unknown
  isDigital?: boolean
}

export interface SerializedSubPlanFilter {
  tabname: string
  countries: number[]
  types: unknown
  excluded: unknown
  is_digital: boolean | ''
  included: unknown
  panels: unknown
  panelsExcluded: unknown
  package: unknown
}

export function serializeFilters(
  planFilters: SubPlanFilter[],
): SerializedSubPlanFilter[] {
  return planFilters.map((subPlanFilters) => {
    return {
      tabname: subPlanFilters.tabname || '',
      countries: serializeCountries(subPlanFilters.countries),
      types: serializePanelTypes(subPlanFilters),
      excluded: subPlanFilters.assets_excluded,
      is_digital: serializeDigitalPanel(subPlanFilters.isDigital),
      included: subPlanFilters.assets_included,
      panels: subPlanFilters.panels,
      panelsExcluded: subPlanFilters.panelsExcluded,
      package: serializePackage(subPlanFilters.package),
    }
  })
}

// SERIALIZE SUB FUNCTIONS

function serializeDigitalPanel(isDigital: boolean | undefined): boolean | '' {
  return isDigital === true || isDigital === false ? isDigital : ''
}

function serializePanelTypes(plan: SubPlanFilter): unknown {
  return plan.types
}

function serializePackage(thePackage: unknown): unknown {
  return thePackage || ''
}

function serializeCountries(data: number[] | null | undefined): number[] {
  return data || []
}
